type PrintOptions = {
  title?: string;
  header?: string;
  customStyles?: string;
};

export const printContent = (contentSelector: string, options?: PrintOptions) => {
  const content = document.querySelector(contentSelector);
  if (!content) {
    console.error('Content not found for selector:', contentSelector);
    return;
  }

  const { title = 'Print Document', header = 'Document', customStyles = '' } = options || {};

  const htmlTemplate = `
    <!DOCTYPE html>
    <html>
      <head>
        <title>${title}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1">
        <style>
          body {
            font-family: 'Sora', sans-serif;
            margin: 0;
            line-height: 1.6;
          }
          ul, ol {
            list-style: none !important;
          }
          .list-inherited ul, .list-inherited ol {
            all: revert !important;
          }
          #printContent {
            padding: 2cm;
            box-sizing: border-box;
          }
          .print-title {
            font-family: 'Sora', sans-serif;
            font-size: 24px;
            font-weight: bold;
            text-align: center;
            margin-bottom: 1cm;
          }
          ${customStyles}
          @media print {
            @page {
              margin: 1cm;
              @top-left { content: none !important; }
              @top-center { content: none !important; }
              @top-right { content: none !important; }
              @bottom-left { content: none !important; }
              @bottom-center { content: none !important; }
              @bottom-right { content: none !important; }
            }
            body { margin: 0; }
            #printContent { padding: 2cm; box-sizing: border-box; }
          }
        </style>
      </head>
      <body>
        <div class="list-inherited" id="printContent">
          <h1 class="print-title">${header}</h1>
        </div>
      </body>
    </html>
  `;

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlTemplate, 'text/html');
  const contentContainer = doc.getElementById('printContent');

  if (!contentContainer) {
    console.error('Failed to find print container');
    return;
  }

  contentContainer.innerHTML += content.innerHTML;

  const dataUrl = 'data:text/html;charset=utf-8,' + encodeURIComponent(doc.documentElement.outerHTML);
  const printWindow = window.open(dataUrl, '_blank');

  if (!printWindow) {
    console.error('Failed to open print window');
    return;
  }

  printWindow.document.documentElement.innerHTML = doc.documentElement.outerHTML;
  printWindow.document.title = title;

  setTimeout(() => {
    printWindow.print();
    printWindow.addEventListener('afterprint', () => {
      printWindow.close();
    });
    setTimeout(() => {
      if (!printWindow.closed) {
        printWindow.close();
      }
    }, 1000);
  }, 100);
};
